import { financesConstants } from '../constants/finances';

const initialState = {
  cancelRequestStatus: 'idle',
  error: null,
  payment: {},
  paymentsData: {
    items: [],
    count: 0,
  },
  paymentOrders: {
    items: [],
    count: 0,
  },
  details: {},
  settings: {},
  redirectToPaymentsData: {}
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case financesConstants.SET_PAYMENT_ORDERS_SUCCESS:
      return {
        ...state,
        paymentOrders: {
          items: action.paymentOrders,
          count: action.count,
        },
      };
    case financesConstants.SET_PAYMENTS_DATA_SUCCESS:
      return {
        ...state,
        paymentsData: {
          items: action.data,
          count: action.count,
        },
      };

    case financesConstants.SET_HOLD_DETAILS_SUCCESS:
      return {
        ...state,
        details: {
          ...state.details,
          ...action.details
        },
      };

    case financesConstants.SET_HOLD_DETAILS_SETTINGS_SUCCESS:
      return {
        ...state,
        settings: {
          ...state.settings,
          ...action.settings
        },
      };
    case financesConstants.REDIRECT_TO_PAYMENTS_DATA:
      return {
        ...state,
        redirectToPaymentsData: {
          ...action.data
        },
      };
    case financesConstants.CLEAR_REDIRECT_TO_PAYMENTS_DATA:
      return {
        ...state,
        redirectToPaymentsData: {},
      };
      case financesConstants.PAYMENT_CANCEL_REQUESTED:
        return {
          ...state,
          cancelRequestStatus: 'pending',
        };
      case financesConstants.PAYMENT_CANCEL_SUCCESS:
        return {
          ...state,
          cancelRequestStatus: 'idle',
        };
      case financesConstants.PAYMENT_CANCEL_FAILURE:
        return {
          ...state,
          cancelRequestStatus: 'idle',
          error: action.payload,
        };
      case financesConstants.CLEAR_ERROR:
        return {
          ...state,
          error: null,
        };
    default:
      return state;
  }
};
